import { Theme } from '@eversports/react-components/design-tokens/theme'
import Card from '@eversports/react-components/primitives/Card'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

import BookableItem, { AssignedSpot } from '../../../typings/BookableItem'
import { SettleWith } from '../../../typings/Product'
import BookableItemBookingDetailsContent from '../common/BookableItemBookingDetailsContent'
import BookingDetailsImage from '../common/BookingDetailsImage'

interface Props {
  bookableItem: BookableItem
  settleWith?: SettleWith | null
  hasSpotBooking: boolean
  assignedSpot?: AssignedSpot
}

const useStyles = makeStyles((theme: Theme) => ({
  activityInformation: {
    flex: '60%',
    padding: theme.layoutSpacing.wide,
  },
}))

const DesktopBookableItemBookingDetails: React.FC<React.PropsWithChildren<Props>> = ({
  bookableItem,
  settleWith,
  hasSpotBooking,
  assignedSpot,
}) => {
  const classes = useStyles()

  const eventSessions =
    settleWith?.__typename === 'Ticket'
      ? settleWith.validForSessions
      : bookableItem.__typename === 'EventBookableItem'
        ? bookableItem.eventSessions
        : undefined

  return (
    <Card raised>
      <Flex justifyContent="space-between">
        <div className={classes.activityInformation}>
          <BookableItemBookingDetailsContent
            bookableItem={bookableItem}
            settleWith={settleWith}
            hasSpotBooking={hasSpotBooking}
            assignedSpot={assignedSpot}
            eventSessions={eventSessions}
          />
        </div>
        {bookableItem.activityImage && <BookingDetailsImage src={bookableItem.activityImage.large} />}
      </Flex>
    </Card>
  )
}

export default React.memo(DesktopBookableItemBookingDetails)
